var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: ['w-5 h-5 text-gray-500', _vm.className],
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.0001 16C6.41783 16 4.87109 15.5308 3.55548 14.6518C2.23987 13.7727 1.21448 12.5233 0.608974 11.0615C0.00346629 9.59966 -0.154962 7.99112 0.153723 6.43928C0.462409 4.88743 1.22434 3.46197 2.34318 2.34315C3.46201 1.22433 4.88749 0.462403 6.43936 0.153721C7.99122 -0.15496 9.59977 0.00346625 11.0616 0.608967C12.5234 1.21447 13.7729 2.23985 14.6519 3.55544C15.531 4.87103 16.0002 6.41775 16.0002 8C15.9978 10.121 15.1542 12.1544 13.6544 13.6542C12.1546 15.154 10.1211 15.9976 8.0001 16ZM8.0001 2C6.8134 2 5.65334 2.3519 4.66664 3.01118C3.67993 3.67047 2.91089 4.60754 2.45675 5.7039C2.00262 6.80026 1.8838 8.00665 2.11532 9.17054C2.34683 10.3344 2.91828 11.4035 3.75741 12.2426C4.59653 13.0818 5.66564 13.6532 6.82954 13.8847C7.99344 14.1162 9.19985 13.9974 10.2962 13.5433C11.3926 13.0891 12.3297 12.3201 12.989 11.3334C13.6483 10.3467 14.0002 9.18669 14.0002 8C13.9986 6.40919 13.3659 4.88399 12.241 3.75912C11.1161 2.63424 9.59093 2.00159 8.0001 2Z",
      "fill": _vm.color
    }
  }), _c('path', {
    attrs: {
      "d": "M19.0002 20C18.735 19.9999 18.4807 19.8946 18.2932 19.707L14.2931 15.707C14.111 15.5184 14.0102 15.2658 14.0125 15.0036C14.0147 14.7414 14.1199 14.4906 14.3053 14.3052C14.4907 14.1198 14.7416 14.0146 15.0038 14.0123C15.266 14.01 15.5186 14.1108 15.7072 14.293L19.7072 18.293C19.847 18.4329 19.9422 18.611 19.9808 18.805C20.0194 18.9989 19.9996 19.2 19.9239 19.3827C19.8482 19.5654 19.7201 19.7215 19.5557 19.8314C19.3913 19.9413 19.198 20 19.0002 20Z",
      "fill": _vm.color
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }